// Recovered compiled webpack factory 44300. Edit this function expression; run npm run build.
(t, e, i) => {
  i.d(e, { I: () => o });
  var n = i(40042);
  let s = [
    "setup",
    "read",
    "resolveKeyframes",
    "preUpdate",
    "update",
    "preRender",
    "render",
    "postRender",
  ];
  var r = i(23867);
  function o(t, e) {
    let i = !1,
      o = !0,
      a = { delta: 0, timestamp: 0, isProcessing: !1 },
      l = () => (i = !0),
      h = s.reduce(
        (t, i) => (
          (t[i] = (function (t, e) {
            let i = new Set(),
              n = new Set(),
              s = !1,
              o = !1,
              a = new WeakSet(),
              l = { delta: 0, timestamp: 0, isProcessing: !1 },
              h = 0;
            function u(e) {
              (a.has(e) && (d.schedule(e), t()), h++, e(l));
            }
            let d = {
              schedule: (t, e = !1, r = !1) => {
                let o = r && s ? i : n;
                return (e && a.add(t), o.add(t), t);
              },
              cancel: (t) => {
                (n.delete(t), a.delete(t));
              },
              process: (t) => {
                if (((l = t), s)) {
                  o = !0;
                  return;
                }
                s = !0;
                let a = i;
                ((i = n),
                  (n = a),
                  i.forEach(u),
                  e && r.Q.value && r.Q.value.frameloop[e].push(h),
                  (h = 0),
                  i.clear(),
                  (s = !1),
                  o && ((o = !1), d.process(t)));
              },
            };
            return d;
          })(l, e ? i : void 0)),
          t
        ),
        {},
      ),
      {
        setup: u,
        read: d,
        resolveKeyframes: c,
        preUpdate: p,
        update: m,
        preRender: f,
        render: v,
        postRender: y,
      } = h,
      g = () => {
        let s = n.W.useManualTiming,
          r = s ? a.timestamp : performance.now();
        ((i = !1),
          s || (a.delta = o ? 1e3 / 60 : Math.max(Math.min(r - a.timestamp, 40), 1)),
          (a.timestamp = r),
          (a.isProcessing = !0),
          u.process(a),
          d.process(a),
          c.process(a),
          p.process(a),
          m.process(a),
          f.process(a),
          v.process(a),
          y.process(a),
          (a.isProcessing = !1),
          i && e && ((o = !1), t(g)));
      };
    return {
      schedule: s.reduce((e, n) => {
        let s = h[n];
        return (
          (e[n] = (e, n = !1, r = !1) => (
            !i && ((i = !0), (o = !0), a.isProcessing || t(g)),
            s.schedule(e, n, r)
          )),
          e
        );
      }, {}),
      cancel: (t) => {
        for (let e = 0; e < s.length; e++) h[s[e]].cancel(t);
      },
      state: a,
      steps: h,
    };
  }
}
